import { render } from "./CommandDetail.vue?vue&type=template&id=55d48d0c"
import script from "./CommandDetail.vue?vue&type=script&lang=js"
export * from "./CommandDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__